import React, { useState, useEffect } from 'react';
import {
  Box,
  // Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  MenuItem,
} from '@material-ui/core';
import Spinner from '../../common/Spinner/Spinner';
import { Button } from "../../common/Button/Button"
import { toast } from "react-toastify";
import FormModalExpertConsultation from './FormModalExpertConsultation';

export default function PersonaDetailExpertConsultationTab({ value, index, title, userExptConsultationPersonaDetails, handleSubmitPersonaDetails, isPersonaLoading, isPersonaFormOpen, setIsPersonaFormOpen, selectedResourceInstanceId, handleFormCancel, setIsFormOpen, isFormOpen, uniqueExpertConsultInstanceId, handleUpdatePersonaDetail, expertConsiltAlreadyFilledPersonaInstanceId, resourcesDetails, isTestimonialScreen }) {
  // const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    "nResourceInstanceId": "",
    "Reason to opt Expert Consultation": '',
    "Theme": '',
    "Expert name": '',
    "Output": ''
  });

  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [expertConsultationResourcesOfUser, setExpertConsultationResourcesOfUser] = useState([])
  const [leftResourcesForAddingPersona, setLeftResourcesForAddingPersona] = useState([])
  const [allResourcePersonaDetails, setAllResourcePersonaDetails] = useState([]);

  // useEffect to use the resoyurces availed by the user, here uson it for disabling of the add persona details button, if there isnt any for that category
  useEffect(() => {
    if (resourcesDetails?.ExpertConsultations) {
      setExpertConsultationResourcesOfUser(resourcesDetails.ExpertConsultations);

      let allExpertConsultation = resourcesDetails?.ExpertConsultations;
      console.log(allExpertConsultation, ">>>>>allExpertConsultation")
      let fillingDefaultDataInPersonaDetails = allExpertConsultation.map((resourceObj) => {
        // checking if persona details exist for the instanceId if exists spread it with resource details and if not set default empty keys
        let findPersonaForInstanceId = userExptConsultationPersonaDetails?.find((personaObj) => personaObj?.nResourceInstanceId == resourceObj?.nResourceInstanceId);
        if (findPersonaForInstanceId) {
          return {
            ...findPersonaForInstanceId,
            ...resourceObj,
            "Expert name": resourceObj["refExternalServicePartner"] ? resourceObj["refExternalServicePartner"] : "",
            "isAlreadyPersonaExisting": true, // if persona already existitng then flag for all persona to show edit button
          }
        } else {
          return {
            "nResourceInstanceId": "",
            "Reason to opt Expert Consultation": '',
            "Theme": '',
            "Expert name": resourceObj["refExternalServicePartner"] ? resourceObj["refExternalServicePartner"] : "",
            "Output": '',
            "isAlreadyPersonaExisting": false, // if persona not already existitng then flag for all persona to show add button
            ...resourceObj,
          }
        }
      })

      setAllResourcePersonaDetails([...fillingDefaultDataInPersonaDetails])

      console.log(userExptConsultationPersonaDetails, ">>>>userExptConsultationPersonaDetails in user expert consult useEffect")
      console.log(uniqueExpertConsultInstanceId, ">>>>uniqueExpertConsultInstanceId");

      const alreadyFilledPersonaResourceIds = userExptConsultationPersonaDetails?.map((obj) => {
        const { nResourceInstanceId } = obj;
        return nResourceInstanceId;
      })
      console.log(alreadyFilledPersonaResourceIds, ">>>alreadyFilledPersonaResourceIds expert consult");

      if (alreadyFilledPersonaResourceIds) {
        const personaDetailResourceAddingLeft = uniqueExpertConsultInstanceId?.filter((resourceId) => !alreadyFilledPersonaResourceIds.includes(resourceId))
        console.log(personaDetailResourceAddingLeft, ">>>>personaDetailResourceAddingLeft");
        setLeftResourcesForAddingPersona(personaDetailResourceAddingLeft);
      }
    } else {
      setExpertConsultationResourcesOfUser([]);
    }
    // setLoading(false);
  }, [resourcesDetails, uniqueExpertConsultInstanceId, userExptConsultationPersonaDetails]);

  if (value !== index) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
  };

  const handleAddEditButton = (rowData, action) => {
    if (action === "edit") {
      console.log(rowData, ">>>>rowData on handleEdit exprt consult");
      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(true);
      setIsModalOpen(true)
    } else if (action === "add") {
      console.log(rowData, ">>>>rowData on handleEdit exprt consult");
      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(false);
      setIsModalOpen(true)
    }

  }

  const handleUpdateButtonClick = (formData) => {
    console.log(formData, ">>>>update form data expt consult");

    if (!formData["nResourceInstanceId"]) {
      toast(String("Resource-ID is required"), {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
      setIsModalOpen(false)
    } else {
      const { nResourceInstanceId,
        "Reason to opt Expert Consultation": reasonToOptExpertConsult,
        Theme,
        "Expert name": expertName,
        Output,
        ...remFormData } = formData
      console.log(remFormData, ">>>>resFormData in expert consult")
      handleUpdatePersonaDetail(
        {
          "Type": "Expert_Consultation",
          "subType": "Expert Consultation",
          "nResourceInstanceId": nResourceInstanceId,
          "fields": {
            "Reason to opt Expert Consultation": reasonToOptExpertConsult,
            "Theme": Theme,
            "Expert name": expertName,
            "Output": Output
          }
        }
      );

      setFormData({
        "nResourceInstanceId": "",
        "Reason to opt Expert Consultation": '',
        "Theme": '',
        "Expert name": '',
        "Output": ''
      })
      setIsEdit(false)
      setIsModalOpen(false)
    }
  }

  // // form to submit new data
  // const renderForm = () => (
  //   <Box>
  //     {isPersonaLoading && <Spinner className="center-screen" />}
  //     {/* <TextField
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       // value={selectedResourceInstanceId}
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     /> */}
  //     <TextField
  //       select
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       SelectProps={{
  //         MenuProps: {
  //           PaperProps: {
  //             style: {
  //               maxHeight: 200, // height of dropdown
  //               width: 300,     // width of dropdown
  //             },
  //           },
  //         },
  //       }}
  //     >
  //       {uniqueExpertConsultInstanceId.map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       name="Reason to opt Expert Consultation"
  //       label="Reason to opt Expert Consultation"
  //       value={formData["Reason to opt Expert Consultation"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />

  //     <TextField
  //       name="Theme"
  //       label="Theme"
  //       value={formData["Theme"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />

  //     <TextField
  //       name="Expert name"
  //       label="Expert name"
  //       value={formData["Expert name"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />

  //     <TextField
  //       name="Output"
  //       label="Output"
  //       value={formData["Output"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />
  //   </Box>
  // );

  // render table to display data
  const renderTable = () => (
    <TableContainer component={Paper} style={{ maxHeight: "405px", overflowY: 'auto' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Resource Id</TableCell>
            <TableCell>Reason to opt Expert Consultation</TableCell>
            <TableCell>Theme</TableCell>
            <TableCell>Expert name</TableCell>
            <TableCell>Output</TableCell>
            {
              !isTestimonialScreen && <TableCell>Action</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {
            userExptConsultationPersonaDetails ? (
              userExptConsultationPersonaDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Reason to opt Expert Consultation"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Theme"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Expert name"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Output"] ?? "N/A"}</TableCell>
                  <TableCell><Button onClick={() => handleAddEditButton(row)}>Edit</Button></TableCell>
                </TableRow>
              ))
            ) : <TableRow>
              <TableCell colSpan={6} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          } */}

          {
            allResourcePersonaDetails ? (
              allResourcePersonaDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"] ?? ""}</TableCell>
                  <TableCell>{row["Reason to opt Expert Consultation"] ?? ""}</TableCell>
                  <TableCell>{row["Theme"] ?? ""}</TableCell>
                  <TableCell>{row["Expert name"] ?? ""}</TableCell>
                  <TableCell>{row["Output"] ?? ""}</TableCell>
                  {
                    !isTestimonialScreen && (
                      <TableCell>
                        {
                          row["isAlreadyPersonaExisting"] ? (
                            <Button onClick={() => handleAddEditButton(row, "edit")}>{"Edit"}</Button>
                          ) : (
                            <Button onClick={() => handleAddEditButton(row, "add")}>{"Add"}</Button>
                          )
                        }
                      </TableCell>
                    )
                  }
                </TableRow>
              ))
            ) : <TableRow>
              <TableCell colSpan={6} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  );

  // handleFormSubmit
  const submitExpertConsultPersonaForm = () => {
    console.log(">>>Submit clicked ");

    const { nResourceInstanceId,
      "Reason to opt Expert Consultation": reasonToOptExpertConsult,
      Theme,
      "Expert name": expertName,
      Output,
      ...remFormData } = formData
    console.log(remFormData, ">>>>remFormData in expert consult")
    let data = {
      "Type": "Expert_Consultation",
      "subType": "Expert Consultation",
      "nResourceInstanceId": nResourceInstanceId,
      "fields": {
        "Reason to opt Expert Consultation": reasonToOptExpertConsult,
        "Theme": Theme,
        "Expert name": expertName,
        "Output": Output
      }
    }
    handleSubmitPersonaDetails(data);
    if (!isPersonaLoading) {
      // handleFormToggle(isPersonaFormOpen);

      setFormData({
        "nResourceInstanceId": "",
        "Reason to opt Expert Consultation": '',
        "Theme": '',
        "Expert name": '',
        "Output": ''
      })

      handleFormToggle();
      setIsModalOpen(false)
    }
  }

  const handleCancelForm = () => {
    setIsFormOpen(false);
    setIsEdit(false);
    setFormData({
      "nResourceInstanceId": "",
      "Reason to opt Expert Consultation": '',
      "Theme": '',
      "Expert name": '',
      "Output": ''
    })

    setIsModalOpen(false)
  }

  console.log(userExptConsultationPersonaDetails, ">>>>>userExptConsultationPersonaDetails in market form");
  console.log(formData, ">>>>>formData");
  console.log(allResourcePersonaDetails, ">>>>>allResourcePersonaDetail in expert consult")
  return (
    <Box style={{ padding: '16px' }} className={`${isPersonaLoading && "set-opacity"}`}>
      {isPersonaLoading && <Spinner className="center" />}
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#6D1B7B' }}>
        {title}
      </Typography>

      {/* {isFormOpen ? renderForm() : renderTable()} */}
      {/* {isPersonaFormOpen ? renderForm() : renderTable()} */}
      {renderTable()}

      {/* <Button
        variant="contained"
        color="primary"
        onClick={handleFormToggle}
        style={{ marginTop: 20, width: '100%' }}
      >
        {isFormOpen ? 'Cancel' : 'Add New Opportunity'}
      </Button> */}
      {/* <Box>
        {
          isFormOpen ?
            // isPersonaFormOpen ?
            <Box display="flex" justifyContent="flex-end" padding="0px 20px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                // onClick={handleFormCancel}
                // onClick={() => setIsFormOpen(false)}
                onClick={() => handleCancelForm()}
                style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Cancel
              </Button>

              {
                !isEdit ? <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={submitExpertConsultPersonaForm}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Submit
                </Button> : <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={() => handleUpdateButtonClick(formData)}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Update
                </Button>
              }

            </Box>
            :
            <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFormToggle}
                style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Add New Persona Detail
              </Button>
            </Box>
          // ""
        }

      </Box> */}

      {/* <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          // onClick={handleFormToggle}
          onClick={() => setIsModalOpen(true)}
          style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
          disabled={expertConsultationResourcesOfUser.length <= 0 || leftResourcesForAddingPersona.length <= 0}
        >
          Add New Persona Detail
        </Button>
      </Box> */}

      <FormModalExpertConsultation
        open={isModalOpen}
        // onClose={() => setIsModalOpen(false)}
        onClose={() => handleCancelForm()}
        isPersonaLoading={isPersonaLoading}
        formData={formData}
        handleInputChange={handleInputChange}
        uniqueExpertConsultInstanceId={uniqueExpertConsultInstanceId}
        isEdit={isEdit}
        handleUpdateButtonClick={handleUpdateButtonClick}
        submitExpertConsultPersonaForm={submitExpertConsultPersonaForm}
        expertConsiltAlreadyFilledPersonaInstanceId={expertConsiltAlreadyFilledPersonaInstanceId}
      />
    </Box>
  );
}
